import { DealsComponent } from "@/features";
import { Deal } from "@/types";
import { useOutletContext } from "react-router-dom"

type ClientOutletContext = {
  deals: Deal[]
  isLoading: boolean
}

export const DealsPage = () => {
  const { deals, isLoading } = useOutletContext<ClientOutletContext>()

  return <DealsComponent deals={deals} isLoading={isLoading} />
}